import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../redux/AuthCRUD'
import { PageDataProvider, useLayout } from '../../../../_metronic/layout/core'
import ReCAPTCHA from 'react-google-recaptcha'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

const recaptchaRef = React.createRef<ReCAPTCHA>();
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA || '';

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const {classes} = useLayout()

  const onReCAPTCHAChange = async (captchaToken: string | null) => {
    if (captchaToken) {
      setCaptchaToken(captchaToken);
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestPassword(values.email, captchaToken)
          .then(({data: {result}}) => {
            setHasErrors(false)
            setLoading(false)
          })
          .catch(({ response: { data: { message } } }) => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus(message)
          })
      }, 1000)
    },
  })

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <div
          id='kt_aside'
          className={clsx('aside', classes.aside.join(' '))}
          data-kt-drawer='false'
          data-kt-drawer-name='aside'
          data-kt-drawer-activate='{default: true, lg: false}'
          data-kt-drawer-overlay='true'
          data-kt-drawer-width="{default:'200px', '300px': '250px'}"
          data-kt-drawer-direction='start'
          data-kt-drawer-toggle='#kt_aside_mobile_toggle'
          style={{backgroundColor: 'rgb(243, 229, 80)', width: '30%', justifyContent: 'center'}}
        >
          <div className='container'>
            <div className='mb-20 d-flex aligns-items-center justify-content-center'>
              <Link to={'/'}>
                <img
                  src='/media/logos/C9ondarkbig.png'
                  alt='Delta Panels logo'
                  style={{width: '247px', height: '65px', objectFit: 'cover'}}
                />
              </Link>
            </div>
            <form
              className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
              noValidate
              id='kt_login_password_reset_form'
              onSubmit={formik.handleSubmit}
            >
              <div className='text-center mb-10'>
                {/* begin::Title */}
                <h1 className='text-dark mb-3'>Forgot Password</h1>
                {/* end::Title */}

                {/* begin::Link */}
                <div>A Password Reset email will be sent to the email address provided below for the instruction in resetting your password.</div>
                {/* end::Link */}
              </div>

              {/* begin::Title */}
              {hasErrors === true && (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{formik.status}</div>
                </div>
              )}

              {hasErrors === false && (
                <div className='mb-10 bg-light-info p-8 rounded'>
                  <div className='text-info'>Password reset email sent. Check your inbox to continue.</div>
                </div>
              )}
              {/* end::Title */}

              {/* begin::Form group */}
              {(hasErrors === undefined || hasErrors === true) && (
                <div className='fv-row mb-10'>
                  <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
                  <input
                    type='email'
                    placeholder=''
                    autoComplete='off'
                    {...formik.getFieldProps('email')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.email && formik.errors.email},
                      {
                        'is-valid': formik.touched.email && !formik.errors.email,
                      }
                    )}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.email}</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* end::Form group */}

              {(hasErrors === undefined || hasErrors === true)  && (
                <div className="d-flex justify-content-center align-items-center mb-5">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={recaptchaSiteKey}
                    onChange={onReCAPTCHAChange}
                  />
                </div>
              )}

              {/* begin::Form group */}
              {(hasErrors === undefined || hasErrors === true)  && (
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                  <button
                    type='submit'
                    id='kt_password_reset_submit'
                    className='btn btn-lg btn-dark fw-bolder me-4 mb-3'
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    {!loading && <span className='indicator-label'>Reset Password</span>}
                    {loading && (
                      <span className='spinner-border spinner-border-sm align-middle'></span>
                    )}
                  </button>
                  <Link to='/login'>
                    <button
                      type='button'
                      id='kt_login_password_reset_form_cancel_button'
                      className='btn btn-lg btn-light fw-bolder mb-3'
                    >
                      Cancel
                    </button>
                  </Link>{' '}
                </div>
              )}
              {/* end::Form group */}
            </form>
          </div>
        </div>
        <div
          style={{
            marginLeft: '30%', 
            width: '100%',
            backgroundImage: `url('/media/misc/delta_banner.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'left center'
          }}
          className='d-flex align-items-center justify-content-center'
        >
        </div>
      </div>
    </PageDataProvider>
  )
}
